export const licenseKey =
	'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogImUxZGI1ZDA0LTEyMjEtNDI4ZS05ZDc2LWU1NzI5OWZkNjBiMCIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjUxCn0=.yEwQXAUen8YUD8rPsMN+xfbqxr8KsT0QdhF9uJ+5qFxOluS2wBTO2tcCUs6yDWqrNoz/STLNau6JFnf91j3egj79IzYZcOZBdTdGb6mR9LET9u6KZznkWW1elIjF0g7QzqyInQ==';
